import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React from 'react';
import CommonHeader from './CommonHeader.js';
import Divider from './Divider.js';
import HeaderName from './HeaderName.js';
import { HeaderNPayMonoButton } from './HeaderNpayButton.js';
import useHeaderBrandLogo from '../../hooks/useHeaderBrandLogo.js';
import styles from './HeaderBrandDepth.module.scss.js';

var _excluded = ["serviceType", "subTitle", "rightComponent", "brandLogo", "href", "isPayApp", "children"],
  _excluded2 = ["href", "text", "blindText"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 * 서비스별 1-depth 헤더
 */
function HeaderBrandDepth(_ref) {
  var _ref$serviceType = _ref.serviceType,
    serviceType = _ref$serviceType === void 0 ? null : _ref$serviceType,
    subTitle = _ref.subTitle,
    rightComponent = _ref.rightComponent,
    _ref$brandLogo = _ref.brandLogo,
    brandLogo = _ref$brandLogo === void 0 ? {} : _ref$brandLogo,
    href = _ref.href,
    isPayApp = _ref.isPayApp,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var subTitleHref = subTitle.href,
    subTitleText = subTitle.text,
    subTitleBlindText = subTitle.blindText,
    subTitleProps = _objectWithoutProperties(subTitle, _excluded2);
  var _useHeaderBrandLogo = useHeaderBrandLogo(brandLogo),
    npayLogo = _useHeaderBrandLogo.npayLogo;
  return /*#__PURE__*/React.createElement(CommonHeader, {
    align: "left",
    rightComponent: rightComponent
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(HeaderNPayMonoButton, _objectSpread({
    isPayApp: isPayApp
  }, npayLogo)), serviceType && /*#__PURE__*/React.createElement(HeaderName, _objectSpread({
    serviceType: serviceType,
    size: "small",
    href: href
  }, props))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("h2", {
    className: cx('area-sub-name')
  }, /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, subTitleProps), {}, {
    href: subTitleHref,
    className: cx('sub-name')
  }), subTitleText, subTitleBlindText && /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, subTitleBlindText)), children));
}

export { HeaderBrandDepth as default };
